__turbopack_context__.v({
  "container": "style-module-scss-module__B83UqW__container",
  "divider": "style-module-scss-module__B83UqW__divider",
  "inner": "style-module-scss-module__B83UqW__inner",
  "links": "style-module-scss-module__B83UqW__links",
  "menuCard": "style-module-scss-module__B83UqW__menuCard",
  "menuContainer": "style-module-scss-module__B83UqW__menuContainer",
  "openMenu": "style-module-scss-module__B83UqW__openMenu",
  "searchSection": "style-module-scss-module__B83UqW__searchSection",
  "title": "style-module-scss-module__B83UqW__title",
});
